<template>
  <div class="searchCardDetails my-2 px-2">
    <div class="row no-gutters">
      <div class="col">
        <div v-if="info.rascunho_id && info.registro && ['C', 'D', 'CR'].indexOf(info.registro.tipo_registro) !== -1">
          <DetailsBoxInfo :title="'Cônjuge 1'"
                          :text="info.pessoas[0].nome_antigo || 'Não informado'" />
          <DetailsBoxInfo v-if="info.pessoas[0].nome && openCard"
                          title="Novo nome"
                          :text="info.pessoas[0].nome" />
          <DetailsBoxInfo v-if="info.pessoas[0].sexo && openCard"
                          title="Sexo"
                          :text="info.pessoas[0].sexo" />
        </div>
        <div v-else>
          <DetailsBoxInfo :title="((info.casamento || info.habilitacaoCasamento) ? 'Cônjuge 1' : 'Registrado')"
                          :text="getName(info)" />
          <DetailsBoxInfo v-if="(info.casamento || info.habilitacaoCasamento) && openCard"
                          title="Novo nome"
                          :text="info.casamento ? info.casamento.registro.pessoas[0].nome :
                            info.habilitacaoCasamento.registro.pessoas[0].nome" />
          <DetailsBoxInfo v-if="(info.casamento || info.habilitacaoCasamento) && openCard"
                          title="Sexo"
                          :text="getSex(info.casamento ? info.casamento.registro.pessoas[0].sexo :
                            info.habilitacaoCasamento.registro.pessoas[0].sexo)" />
        </div>
      </div>

      <b-link v-if="(info.tipo_livro === 'O') && info.obito"
              class="btn btn--xs align-self-start btn-sm btn-outline-dark"
              :to="{ name: 'resumo_obito', params: { id: info.obito ? info.obito.obito_id : null } }">
        Resumo de óbito
      </b-link>
      <div class="col">
        <div v-if="info.rascunho_id && info.registro && ['C', 'D', 'CR'].indexOf(info.registro.tipo_registro) !== -1">
          <DetailsBoxInfo :title="'Cônjuge 2'"
                          :text="info.pessoas[1].nome_antigo || 'Não informado'" />
          <DetailsBoxInfo v-if="info.pessoas[1].nome && openCard"
                          title="Novo nome"
                          :text="info.pessoas[1].nome" />
          <DetailsBoxInfo v-if="info.pessoas[1].sexo && openCard"
                          title="Sexo"
                          :text="info.pessoas[1].sexo" />
        </div>
        <div v-else>
          <DetailsBoxInfo v-if="(info.casamento || info.habilitacaoCasamento)"
                          title="Cônjuge 2"
                          :text="info.casamento ? info.casamento.registro.pessoas[1].nome_antigo :
                            info.habilitacaoCasamento.registro.pessoas[1].nome_antigo" />
          <DetailsBoxInfo v-if="(info.casamento || info.habilitacaoCasamento) && openCard"
                          title="Novo nome"
                          :text="info.casamento ? info.casamento.registro.pessoas[1].nome :
                            info.habilitacaoCasamento.registro.pessoas[1].nome" />
          <DetailsBoxInfo v-if="(info.casamento || info.habilitacaoCasamento) && openCard"
                          title="Sexo"
                          :text="getSex(info.casamento ? info.casamento.registro.pessoas[1].sexo :
                            info.habilitacaoCasamento.registro.pessoas[1].sexo)" />
        </div>
      </div>
      <div class="col-2">
        <a v-if="!info.flag_cancelado"
           v-ripple
           :href="openItem(info).href"
           class="btn btn-block btn-outline-primary btn-sm">
          Acessar
        </a>
        <button v-if="info.flag_cancelado"
                disabled
                class="btn btn-block btn-outline-primary  btn-sm">
          Cancelado
        </button>
      </div>
      <div v-if="openCard && !info.rascunho_id"
           class="col-12">
        <DetailsBoxInfo title="Matrícula"
                        :text="info.matricula" />
      </div>
    </div>
  </div>
</template>

<script>
  import DetailsBoxInfo from './DetailsBoxInfo'

  export default {
    name: "SearchCardDetails",
    components: {
      DetailsBoxInfo
    },
    props: [ 'info', 'openCard', 'propSegundaVia' ],
    methods: {
      getName (value) {
        let nome = ''
        let tipo = value.casamento || value.nascimento || value.obito || value.habilitacaoCasamento || {}

        if (!value.habilitacaoCasamento && !value.casamento) {
          nome = ('nome_registrado_1' in tipo) && 'nome_registrado_1' ||
            ('nome_registrado' in tipo) && 'nome_registrado'
        } else if (value.casamento) {
          return value.casamento.registro.pessoas[0].nome_antigo
        } else {
          return value.habilitacaoCasamento.registro.pessoas[0].nome_antigo
        }

        if (!nome && value.rascunho_id && value.nome) {
          return value.nome
        } else if (tipo[nome]) {
          return tipo[nome]
        } else if (value.pessoa && value.pessoa.nome) {
          return value.pessoa.nome
        }
        else if (!nome && value.rascunho_id && value.nome_registrado ) {
          return value.nome_registrado
        }
        else if (!nome && value.registro.pessoa.nome) {
          return value.registro.pessoa.nome
        }
        else {
          return 'Não Informado'
        }
      },
      getSex (value) {
        if (value === 'Feminino' || value === 'Masculino') {
          return value
        }

        return value === 'F' ? 'Feminino' : 'Masculino'
      },
      openItem (item) {
        if (item.rascunho_id) {
          return this.openRascunho(item)
        } else {
          return this.openRegistro(item)
        }
      },
      openRascunho (rascunho) {
        let { rascunho_id, registro: { tipo_registro } } = rascunho

        let tipos = {
          'O': 'obito',
          'NT': 'obito',
          'N': 'nascimento',
          'D': 'habilitar-casamento',
          'C': 'casamento',
          'CR': 'casamento'
        }

        if (tipos[tipo_registro]) {
          let router
          if (this.propSegundaVia) {
            router = `/${tipos[tipo_registro] + "-legado"}/${rascunho_id}`
          } else {
            router = `/${tipos[tipo_registro]}/${rascunho_id}`
          }

          return this.$router.resolve(router)
        }

      },
      openRegistro (registro) {
        let router, id

        if (registro.obito) {
          id = registro.obito.obito_id
          router = `/obito/resumo/${id}`
        }

        if (registro.nascimento) {
          id = registro.nascimento.nascimento_id
          router = `/nascimento/resumo/${id}`
        }

        if (registro.casamento) {
          id = registro.casamento.casamento_id
          router = `/casamento/resumo/${id}`
        }

        if (registro.habilitacaoCasamento) {
          id = registro.habilitacaoCasamento.habilitacao_casamento_id
          router = `/habilitar-casamento/resumo/${id}`
        }

        return this.$router.resolve(router)
      },
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .searchCardDetails {}

  .teste {
    word-break: break-all;
  }
</style>
